/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from 'react';

import OhsSysFieldCusvalGroup from 'global-components/form/sys-fields/OhsSysFieldCusvalGroup';
import { fetchInjuryMgmtTemplate } from 'injury-mgmt/OhsInjuryMgmtServices';
import { OhsFormLayoutType, OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import OhsDebouncedButton from 'global-components/buttons/OhsDebouncedButton';

import { fetchMasterRecord, fetchMasterRecordList } from './SysFieldTestServices';

// TODO - use first item from listing instead
const TEST_ID = '68ad334a6fb250ccea4533dc';
// 6848fd6531373c5dd668de42
// 684fa203ce5c6e3665110ddf
// 685de9baeb7cea77a29f0ec2
// 6863547c40062eb5a2b7a1e2
// 6864a18d348fdc74f2e3ff66
// 68ad334a6fb250ccea4533dc

function SysFieldCusvalGroupRealData() {
  const [selectedRecord, setSelectedRecord] = useState<any>({});
  const [layout, setLayout] = useState<any>([]);
  const [templateData, setTemplateData] = useState<any>({});

  const ohsFormSettings = new OhsFormSettings({}, OhsFormLayoutType.AngularPageForm);

  // const fetchList = async () => {
  //   const res = await fetchMasterRecordList();
  //   console.log('res: ', res);
  // };

  const fetchRecord = async () => {
    // TODO - current BE fetch does not work
    const record = await fetchMasterRecord(TEST_ID);
    const template = await fetchInjuryMgmtTemplate(record?.template?._id);
    setTemplateData(template);

    const newForm = {
      sys_id: [...(record?.sysfields || []), ...(record?.cusvals || [])],
    };
    ohsFormSettings.useFormMethods.reset(newForm);
    setSelectedRecord(record);

    if (template) {
      setLayout(template?.record?.layout[0]?.items || []);
    }
  };

  const formSubmit = async (data: any) => {};

  useEffect(() => {
    // fetchList();
    fetchRecord();
  }, []);

  return (
    <>
      <OhsSysFieldCusvalGroup
        templateId={templateData?._id}
        recordId=""
        id="sys_id"
        ohsFormSettings={ohsFormSettings}
        cusvalConfig={selectedRecord?.cusvals || []}
        sysFieldConfig={selectedRecord?.sysfields || []}
        layout={layout}
      />
      <OhsDebouncedButton
        color="green"
        onClick={ohsFormSettings.useFormMethods.handleSubmit((data: any) => formSubmit(data))}
      >
        Submit
      </OhsDebouncedButton>
    </>
  );
}

export default SysFieldCusvalGroupRealData;
